// src/Components/Reports/AccessReport/columnsAccessReport.js

import { utils } from "../../../Helpers/utils";

export const columnsPersonasAccessReport = [
  {
    fieldName: "name",
    name: "Nombre",
    width: "160px",
    filter: true,
  },
  {
    fieldName: "dateIn",
    name: "Fecha de Entrada",
    width: "160px",
    filter: true,
    body: (item) => item.dateIn,
  },
  {
    fieldName: "dateOut",
    name: "Fecha de Salida",
    width: "160px",
    filter: true,
    body: (item) =>
      !utils.isNullOrEmpty(item.dateOut) ? item.dateOut : "En el lugar",
  },
  {
    fieldName: "comment",
    name: "Comentario",
    width: "200px",
    filter: true,
    body: (item) => item.comment || "Sin comentario",
  },
];
